import m from "./examples.mobile.json.mjs";
import { getExampleNumber as o } from "./getExampleNumber.mjs";
const n = { minLength: 10, maxLength: 15 }, h = (r) => {
  try {
    const t = o(
      r,
      m
    );
    if (!t)
      return n;
    const e = t.nationalNumber;
    return {
      minLength: e.length,
      maxLength: e.length
    };
  } catch {
    return n;
  }
};
export {
  h as getPhoneLengthsByCountry
};
//# sourceMappingURL=getPhoneLengthsByCountry.mjs.map
